import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=e945e848&lang=css"

const __exports__ = script;

export default __exports__